export default __webpack_public_path__ + "static/media/team-photo-2020.60d507bc.jpg";